import { type ChangeEventHandler, type FC } from 'react';
import { useUnit } from 'effector-react';
import { Group, TextInput } from '@mantine/core';
import { useDebouncedField } from '~/shared/lib/hooks/useDebouncedField';
import { $cascadesFilter, setCascadesFilter } from '../model';

export const CascadesFilter: FC = () => {
    const filter = useUnit($cascadesFilter);

    const name = useDebouncedField({
        initialValue: filter.name?.value ?? '',
        onChange: (value: string) => setCascadesFilter({ name: { value } }),
    });

    const id = useDebouncedField({
        initialValue: filter.id?.value ?? '',
        onChange: (value: string) => setCascadesFilter({ id: { value } }),
    });

    const handleChangeName: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        name.onChange(value);
    };

    const handleChangeId: ChangeEventHandler<HTMLInputElement> = ({ currentTarget: { value } }) => {
        id.onChange(value);
    };

    return (
        <Group
            wrap='wrap'
            gap='md'
        >
            <TextInput
                flex={1}
                size='xs'
                miw={240}
                label='Название'
                placeholder='Введите название'
                value={name.value}
                onChange={handleChangeName}
            />

            <TextInput
                flex={1}
                size='xs'
                miw={240}
                label='ID'
                placeholder='Введите ID'
                value={id.value}
                onChange={handleChangeId}
            />
        </Group>
    );
};
